import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-05/lesson-21/task-03";

const task: Slide = {
  titleHtml:
    "Will a realistic triple-pane window provide better sound insulation than a double-pane<br>window of similar total thickness and mass?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
